import { gql } from '@apollo/client';
import AgreementFragment from './fragments/agreement.fragment';

export default gql`
  mutation registerAgreementAccord($input: RegisterAgreementAccordInput!) {
    registerAgreementAccord(input: $input) {
      ...AgreementFragment
    }
  }
  ${AgreementFragment}
`;
